var _rect, _path;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var s = Object.getOwnPropertySymbols(e); for (r = 0; r < s.length; r++) o = s[r], t.includes(o) || {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (e.includes(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgHotmartIcon(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 64 64",
    width: 64,
    height: 64,
    role: "img",
    "aria-label": "Hotmart",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    width: 64,
    height: 64,
    rx: 14,
    fill: "#F04E23"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M33.9 10.6c1.2 5.6-1.1 8.9-4.2 12.2-3.4 3.6-7.5 7-8.9 12.9-1.9 8 3.1 15.6 11 17.4-2.4-2.6-3.4-5.6-2.7-8.9.7-3.4 3-5.7 5.2-8 2-2.1 3.9-4.2 4.6-7.1 1.9 2.1 2.8 4.4 2.9 6.9 2.6-2.4 3.9-5.3 4-8.6 2.6 3.4 3.9 7.2 3.7 11.3-.3 6.7-4.6 12.2-10.7 14.4 8.9-1 15.6-8.4 15.9-17.3.2-6.1-2.7-11.5-7.3-15.4.1 2-.4 3.7-1.5 5.2-.2-6.2-3.4-11-8.6-14.2-1.1-.7-2.2-1.3-3.4-1.8z",
    fill: "#fff"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgHotmartIcon);
export default __webpack_public_path__ + "static/media/hotmart_icon.1f859e3499ce28a56e2200fdffde0c82.svg";
export { ForwardRef as ReactComponent };